import { CONFIG } from '../config';
import styles from './Onchain.module.css';

export default function Onchain() {
  return (
    <section className={styles.section} id="onchain">
      <div className={styles.tag}>Built Onchain</div>
      <h2 className={styles.title}>Base Network Native</h2>
      <p className={styles.desc}>Every action is transparent, verifiable, and executed directly on the Base blockchain.</p>

      <div className={styles.grid}>
        {CONFIG.onchainFeatures.map((f) => (
          <div key={f.title} className={styles.card}>
            <div className={styles.iconWrap}>{f.icon}</div>
            <div>
              <div className={styles.cardTitle}>{f.title}</div>
              <p className={styles.cardDesc}>{f.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
